<template>
  <nav class="bottom-nav">
    <div
      v-for="tab in tabs"
      :key="tab.key"
      class="nav-tab"
      :class="{ 'nav-tab--active': activeTab === tab.key }"
      @click="onClick(tab)"
    >
      <div class="nav-tab-icon">
        <img v-if="activeTab === tab.key" class="tab-svg" :src="tab.activeIcon" alt="" />
        <img v-else class="tab-svg" :src="tab.inactiveIcon" alt="" />
      </div>
      <span class="nav-tab-text">{{ tab.label }}</span>
    </div>
  </nav>
</template>

<script>
import { getMessages } from '@/i18n'

const tabs = [
  {
    key: 'home',
    route: 'home',
    activeIcon: require('@/assets/home/home-active.png'),
    inactiveIcon: require('@/assets/home/home-btn.png'),
  },
  {
    key: 'invest',
    route: 'invest',
    activeIcon: require('@/assets/home/invest-active.png'),
    inactiveIcon: require('@/assets/home/icon-invest.svg'),
  },
  {
    key: 'withdraw',
    route: 'withdraw',
    activeIcon: require('@/assets/home/withdraw-active.png'),
    inactiveIcon: require('@/assets/home/icon-withdraw.svg'),
  },
  {
    key: 'team',
    route: 'team',
    activeIcon: require('@/assets/home/team-active.png'),
    inactiveIcon: require('@/assets/home/icon-team.svg'),
  },
]

export default {
  name: 'BottomNav',
  props: {
    activeTab: { type: String, required: true },
  },
  computed: {
    tabs() {
      const lang = localStorage.getItem('lang') || 'en'
      const t = getMessages(lang)
      const labels = { home: t.tabHome, invest: t.tabInvest, withdraw: t.tabWithdraw, team: t.tabTeam }
      return tabs.map(tab => ({ ...tab, label: labels[tab.key] }))
    },
  },
  methods: {
    onClick(tab) {
      if (this.activeTab !== tab.key) {
        this.$router.push({ name: tab.route })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 340px;
  margin: 0 auto;
  margin-bottom: 20px;
  padding: 13px 25px 11px 24px;
  box-sizing: border-box;
  background: linear-gradient(128deg, #341618 0%, #130f0f 100%);
  border-radius: 90px;
  z-index: 100;
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav-tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  cursor: pointer;
  width: 48px;
  flex-shrink: 0;
}

.nav-tab-icon {
  width: 27px;
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab-svg {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.nav-tab-text {
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  white-space: nowrap;
}

.nav-tab--active .nav-tab-text {
  color: #fff;
}
</style>
